import { useTranslation } from 'react-i18next';
import { ConfigProvider, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';
import moment from 'moment';
import 'dayjs/locale/pl';
import 'dayjs/locale/en';
import 'dayjs/locale/tr';
import 'dayjs/locale/fr';
import 'dayjs/locale/es';
import 'dayjs/locale/uk';
import 'dayjs/locale/de';
import 'dayjs/locale/hu';
import 'moment/dist/locale/pl';
import 'moment/dist/locale/tr';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/es';
import 'moment/dist/locale/uk';
import 'moment/dist/locale/de';
import 'moment/dist/locale/hu';

import './App.scss';
import Main from './pages/Main';
import { useDeepLinks, usePushNotifications } from './hooks';
import { AntdLocales, type LanguageKey } from './i18n/constants';
import { LocalizationForm } from './components/Localization/index.jsx';
import { ModalWidthSmall } from './constants/ui';
import { LocalizationModal } from './constants/keys';
// import { UpdateApp } from './components/UpdateApp/index.jsx';

function App() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [modalLocalizationOpen, setModalLocalizationOpen] = useState(false);

  // QR code
  useDeepLinks();

  // Push notifications
  usePushNotifications({ navigate }).then();

  useEffect(() => {
    const wasShown = localStorage.getItem(LocalizationModal) === '1';
    if (!wasShown) {
      setModalLocalizationOpen(true);
    }
  }, []);

  const currentLang = i18n.language as LanguageKey;

  useEffect(() => {
    document.documentElement.lang = currentLang;
  }, [currentLang]);

  dayjs.locale(currentLang);
  moment.locale(currentLang);

  const closeLocalizationModal = () => {
    localStorage.setItem(LocalizationModal, '1');
    setModalLocalizationOpen(false);
  };

  return (
    <ConfigProvider locale={AntdLocales[currentLang]}>
      <Main />
      {/*{<UpdateApp />}*/}

      {/*Choose language*/}
      <Modal
        onCancel={closeLocalizationModal}
        footer={false}
        centered
        open={modalLocalizationOpen}
        title={''}
        width={ModalWidthSmall}
      >
        <LocalizationForm onDone={closeLocalizationModal} />
      </Modal>
    </ConfigProvider>
  );
}

export default App;
